// #region Imports

/* Telestream */
import { getMetadataTrack, getAudioMetersTrack } from '../../components/panes/components/timeline/utilities/cue-utilities';

// #endregion Imports

export function findNextMarkerTime(context) {
  const frameDuration = (1 / context.state.framerate);
  const DELTA = (frameDuration / 2);

  const metadataCues = getMetadataCues(context.state.element, context.state.selectedWaveformMarks);
  const nextMetadataCue = findNextCue(metadataCues, context.state.currentTime + DELTA);

  const nielsenCues = getNielsenCues(context.state.element, context.state.selectedWaveformMarks);
  const nextNielsenCue = findNextCue(nielsenCues, context.state.currentTime + DELTA);

  if (!nextMetadataCue && !nextNielsenCue) {
    return undefined;
  } else if (!nextMetadataCue && !!nextNielsenCue) {
    return nextNielsenCue.startTime;
  } else if (!!nextMetadataCue && !nextNielsenCue) {
    return nextMetadataCue.startTime;
  } else {
    return nextMetadataCue.startTime < nextNielsenCue.startTime ? nextMetadataCue.startTime : nextNielsenCue.startTime;
  }
}

export function findPreviousMarkerTime(context) {
  /*
   * Quick note on the DELTA, or rather, lack there-of, in this operation:
   * Since we are searching for the previous cue by end time, but are jumping to
   * the start time, the DELTA is already "built in" so to say.
   */

  const metadataCues = getMetadataCues(context.state.element, context.state.selectedWaveformMarks);
  const previousMetadataCue = findPreviousCue(metadataCues, context.state.currentTime);

  const nielsenCues = getNielsenCues(context.state.element, context.state.selectedWaveformMarks);
  const previousNielsenCue = findPreviousCue(nielsenCues, context.state.currentTime);

  if (!previousMetadataCue && !previousNielsenCue) {
    return undefined;
  } else if (!previousMetadataCue && !!previousNielsenCue) {
    return previousNielsenCue.startTime;
  } else if (!!previousMetadataCue && !previousNielsenCue) {
    return previousMetadataCue.startTime;
  } else {
    return previousMetadataCue.startTime > previousNielsenCue.startTime ? previousMetadataCue.startTime : previousNielsenCue.startTime;
  }
}

export function findPreviousIFrameTime(context) {
  const metadataTrack = getMetadataTrack(context.state.element);

  let previousCue = undefined;
  for (let metadataCueIndex = 0; metadataCueIndex < metadataTrack.cues.length; metadataCueIndex++) {
    const cue = metadataTrack.cues[metadataCueIndex];
    
    if (cue.value.info.sampleType === '0') {
      if (cue.endTime > context.state.currentTime) {
        return previousCue.startTime;
      }

      previousCue = cue;
    }
  }

  return undefined;
}

export function findNextIFrameTime(context) {
  const metadataTrack = getMetadataTrack(context.state.element);

  for (let metadataCueIndex = 0; metadataCueIndex < metadataTrack.cues.length; metadataCueIndex++) {
    const cue = metadataTrack.cues[metadataCueIndex];
    if (
      (cue.startTime > context.state.currentTime) &&
      (cue.value.info.sampleType === '0')
    ) {
      return cue.startTime;
    }
  }

  return undefined;
}

function getMetadataCues(videoElement, selectedMarks) {
  if (!selectedMarks.includes('SCTE-35') && !selectedMarks.includes('SCTE-104')) {
    return [];
  }

  const metadataTrack = getMetadataTrack(videoElement);
  if (!metadataTrack) {
    return [];
  }

  const filteredCues = [];
  for (let metadataCueIndex = 0; metadataCueIndex < metadataTrack.cues.length; metadataCueIndex++) {
    const cue = metadataTrack.cues[metadataCueIndex];
    if (selectedMarks.includes('SCTE-35') && cue.value.info.hasScte35) {
      filteredCues.push(cue);
    }

    if (selectedMarks.includes('SCTE-104') && cue.value.info.hasScte104) {
      filteredCues.push(cue);
    }
  }

  return filteredCues;
}

function getNielsenCues(videoElement, selectedMarks) {
  if (!selectedMarks.includes('Nielsen')) {
    return [];
  }

  const metadataTrack = getAudioMetersTrack(videoElement, 0);
  if (!metadataTrack) {
    return [];
  }

  const filteredCues = [];
  for (let metadataCueIndex = 0; metadataCueIndex < metadataTrack.cues.length; metadataCueIndex++) {
    const cue = metadataTrack.cues[metadataCueIndex];
    if (cue.value.meter.nielsen) {
      filteredCues.push(cue);
    }
  }

  return filteredCues;
}

function findPreviousCue(cues, from) {
  for (let cueIndex = cues.length - 1; cueIndex >= 0; cueIndex--) {
    const cue = cues[cueIndex];
    if (cue.endTime < from) {
      return cue;
    }
  }
}

function findNextCue(cues, from) {
  for (let cueIndex = 0; cueIndex < cues.length; cueIndex++) {
    const cue = cues[cueIndex];
    if (cue.startTime > from) {
      return cue;
    }
  }
}